import type { CalculationType } from "./utils/api";

export const ROUTES = {
  home: "/",
  carAffordability: "/car-affordability",
  homeAffordability: "/home-affordability",
  bondRepayment: "/bond-repayment",
  tax: "/tax",
  monthlyFinances: "/monthly-finances",
  about: "/about",
  callback: "/callback",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];

const LEGACY_HASH: Record<string, AppRoute> = {
  "#home": ROUTES.home,
  "#affordability": ROUTES.carAffordability,
  "#tax": ROUTES.tax,
  "#monthlyfinances": ROUTES.monthlyFinances,
  "#about": ROUTES.about,
};

/** Map old hash URLs (and optional session tab) to path routes. */
export function legacyHashToPath(hash: string): AppRoute | null {
  const key = hash.trim().toLowerCase();
  if (key === "#affordability") {
    try {
      const pending = sessionStorage.getItem("totties:affordabilityTab");
      sessionStorage.removeItem("totties:affordabilityTab");
      if (pending === "home") return ROUTES.homeAffordability;
      if (pending === "bond") return ROUTES.bondRepayment;
    } catch {
      /* ignore */
    }
    return ROUTES.carAffordability;
  }
  return LEGACY_HASH[key] ?? null;
}

export function routeForCalculationType(
  type: CalculationType,
  payload?: Record<string, unknown>,
): AppRoute {
  switch (type) {
    case "affordability":
      return payload?.activeCalculator === "home"
        ? ROUTES.homeAffordability
        : ROUTES.carAffordability;
    case "bond":
      return ROUTES.bondRepayment;
    case "tax":
      return ROUTES.tax;
    case "monthlyFinances":
      return ROUTES.monthlyFinances;
    default:
      return ROUTES.home;
  }
}

export function isLandingPath(pathname: string): boolean {
  return pathname === ROUTES.home;
}

export function pageTitleForPath(pathname: string): string {
  switch (pathname) {
    case ROUTES.home:
      return "Home";
    case ROUTES.carAffordability:
      return "Car Affordability";
    case ROUTES.homeAffordability:
      return "Home Affordability";
    case ROUTES.bondRepayment:
      return "Bond Repayment";
    case ROUTES.tax:
      return "Tax Calculator";
    case ROUTES.monthlyFinances:
      return "Monthly Finances";
    case ROUTES.about:
      return "About";
    default:
      return "Totties";
  }
}
